import { getDashboardStats } from '@/services/dashboard.service'

export default {
	namespaced: true,
	state: {
		stats: null,
		status: 'pending',
	},
	getters: {
		getDashboardStats(state) {
			return state.stats
		},
		getDashboardStatus(state) {
			return state.status
		},
	},
	mutations: {
		SET_STATS(state, value) {
			state.stats = value
		},
		SET_STATUS(state, value) {
			state.status = value
		},
	},
	actions: {
		async fetchDashboardStats({ commit }, params = {}) {
			commit('SET_STATUS', 'loading')
			commit('SET_STATS', null)
			try {
				const { data } = await getDashboardStats(params)
				commit('SET_STATS', data)
				commit('SET_STATUS', 'ready')
				return data
			} catch (error) {
				commit('SET_STATUS', 'error')
				throw error
			}
		},
	},
}
